import {
  Directive,
  ElementRef,
  HostListener,
  Renderer2
} from '@angular/core';

@Directive({
  selector: '[clickOutsideClose]'
})
export class ClickOutsideCloseDirective {
  constructor(private el: ElementRef, private renderer: Renderer2) { }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const clickedInside = this.el.nativeElement.contains(event.target);
    if (!clickedInside) {
      const toggleButton = this.el.nativeElement.querySelector('.dropdown-btn');
      toggleButton?.click();
    }
  }
}
